/**
 * Consolidated universal loaders for config with Zod validation.
 * These are safe for client and server usage (no DB access).
 * 
 * IMPORTANT: This file is imported on both client and server.
 * On the client, we use static defaults from preferences.config.
 * On the server, loaders.server.ts provides brand-merged values.
 */
import { adminPreferences as defaultAdminPreferences } from '#app/config/admin/preferences.config'
import { navigationRoutes } from '#app/config/navigation/routes.config'
import { permissions } from '#app/config/permissions/permissions.config'

import { adminPreferencesSchema } from './schemas/adminPreferencesSchema'
import { navigationRoutesSchema } from './schemas/navigationRoutesSchema'
import { permissionsSchema } from './schemas/permissionsSchema'

// Admin Preferences (universal) - use static defaults
// On the client, we use static defaults. The server-side loaders.server.ts
// provides the properly merged version with brand config via root loader.
// Components should use the values from root loader data, not this static export.
export const AdminPrefs = adminPreferencesSchema.parse(defaultAdminPreferences)
export type AdminPreferences = typeof AdminPrefs

// Aggregated Navigation Routes (universal) - TypeScript config
export const NavigationRoutes = navigationRoutesSchema.parse(navigationRoutes)
export type NavigationRoutesConfig = typeof NavigationRoutes

// Permissions (universal)
export const Permissions = permissionsSchema.parse(permissions)
export type PermissionsConfig = typeof Permissions
